import {Tag} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

/**
 * Kết quả validate JSON-LD (3 lớp) từ BE:
 * {valid, errors[], warnings[], detected_type, rich_result_eligible}.
 */
function ValidationResult({result}) {
	if (!result) return null;

	const {valid, errors = [], warnings = [], detected_type, rich_result_eligible} = result;

	return (
		<div className={cn('vr')}>
			<div className={cn('vr-summary')}>
				<Tag color={valid ? 'green' : 'red'} className={cn('vr-badge')}>
					<FontAwesomeIcon icon={valid ? 'fa-light fa-circle-check' : 'fa-light fa-circle-xmark'} />{' '}
					{valid ? 'Hợp lệ' : 'Có lỗi'}
				</Tag>
				{detected_type && <Tag color="blue">Type: {detected_type}</Tag>}
				<Tag color={rich_result_eligible ? 'green' : 'default'}>
					{rich_result_eligible ? 'Đủ điều kiện rich result' : 'Chưa đủ rich result'}
				</Tag>
			</div>

			{errors.length > 0 && (
				<div className={cn('vr-block', 'vr-errors')}>
					<div className={cn('vr-head')}>
						<FontAwesomeIcon icon="fa-light fa-circle-xmark" /> Lỗi ({errors.length})
					</div>
					<ul>
						{errors.map((e, i) => (
							<li key={i}><code>{e.field}</code> — {e.message}</li>
						))}
					</ul>
				</div>
			)}

			{warnings.length > 0 && (
				<div className={cn('vr-block', 'vr-warnings')}>
					<div className={cn('vr-head')}>
						<FontAwesomeIcon icon="fa-light fa-triangle-exclamation" /> Cảnh báo ({warnings.length})
					</div>
					<ul>
						{warnings.map((w, i) => (
							<li key={i}><code>{w.field}</code> — {w.message}</li>
						))}
					</ul>
				</div>
			)}

			{valid && errors.length === 0 && warnings.length === 0 && (
				<div className={cn('vr-clean')}>
					<FontAwesomeIcon icon="fa-light fa-circle-check" /> Không phát hiện vấn đề nào.
				</div>
			)}
		</div>
	);
}

export default ValidationResult;
